<div class="content">
  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

    <ng-container matColumnDef="discountName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="discountName" class="cell_club">Nom de la réduction</th>
      <td mat-cell *matCellDef="let element" class="cell_club"> {{element.promoCodeName}} </td>
    </ng-container>

    <ng-container matColumnDef="clubCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="clubCode" class="cell_club">Code du club</th>
      <td mat-cell *matCellDef="let element" class="cell_club"> {{element.clubCode}} </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="amount" class="cell_club">Montant</th>
      <td mat-cell *matCellDef="let element" class="cell_club"> {{element.promoAmount || '-'}}{{element.promoAmount? '€'
        : null}} </td>
    </ng-container>

    <ng-container matColumnDef="percentage">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="percentage" class="cell_club">Pourcentage</th>
      <td mat-cell *matCellDef="let element" class="cell_club"> {{element.promoPercentage ||
        '-'}}{{element.promoPercentage? '%' : null}} </td>
    </ng-container>

    <ng-container matColumnDef="startDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="startDate" class="cell_club">Date de début</th>
      <td mat-cell *matCellDef="let element" class="cell_club"> {{element?.promoStartDate | date: "dd/MM/YYYY HH:mm" }} </td>
    </ng-container>

    <ng-container matColumnDef="endDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="endDate" class="cell_club">Date de fin</th>
      <td mat-cell *matCellDef="let element" class="cell_club"> {{element?.promoEndDate | date: "dd/MM/YYYY HH:mm" }} </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef class="cell_action"> Actif </th>
      <td mat-cell *matCellDef="let element" class="cell_action">
        <fa-icon [icon]="isActiveOrDeactive(element) ? getFaIcon('faCheckCircle') : getFaIcon('faTimesCircle')"
          [ngClass]="{isActive: isActiveOrDeactive(element), isDeactive: !isActiveOrDeactive(element) }"></fa-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef class="cell_action"> Editer </th>
      <td mat-cell *matCellDef="let element" class="cell_action">
        <fa-icon [icon]="getFaIcon('faPen')" class="actionBtn" (click)="addOrEditDiscount('edit', element)" appChangeColorTheme
          attribute="color"></fa-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef class="cell_action"> Supp. </th>
      <td mat-cell *matCellDef="let element" class="cell_action">
        <fa-icon [icon]="getFaIcon('faTrashAlt')" class="actionBtn" (click)="deleteDiscount(element)" appChangeColorTheme
          attribute="color"></fa-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>

  </table>

  <div class="no_discount" *ngIf="!dataSource?.filteredData.length">
    Aucun code promo
  </div>

  <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event"
    [color]="color">
  </mat-paginator>
</div>
